var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.define_Data_class = function (in_implements) {
    var implements = [Options, new Class(OCS.Interfaces.BaseData), new Class(OCS.Interfaces.UniqueId)];
    if (in_implements && in_implements.length) {
        implements.combine(in_implements);
    } else {
        implements.push(new Class(OCS.Interfaces.DataTypeDefault));
    }
    return new Class({
        Implements: implements,
        class_type: "Data",
        class_name: "Data",
        data_type: 'Data',
        dataset_obj: null,
        initialize: function (op) {
            if (!op) {
                return this;
            }
            if (OCS.Utilities.is_string(op)) {
                op = this.parse(op);
            }
            if (!op) {
                return this;
            }
            if (op.metadata) {
                this.process_metadata(op);
            }
            if (op.entry && op.entry.json) {
                if (op.entry.json.info && Object.keys(op.entry.json.info)) {
                    var info = op.entry.json.info;
                    if (info.timestamp) {
                        info.timestamp = this.parse_datetime(info.timestamp);
                    }
                    if (info.parm && OCS.Utilities.is_string(info.parm)) {
                        info.parm = String(info.parm).split(',');
                    }
                    if (info.units && OCS.Utilities.is_string(info.units)) {
                        info.units = String(info.units).split(',');
                    }
                }
            }

            this.setOptions(op);
            var ds = this.get_dataset_obj();
            if (ds && ds.options.dataset && ds.options.dataset.length) {
                this.options.entry.json.dataset = ds.options.dataset;
            }
        },
        process_metadata: function (op) {
            if (!op.entry.json.dataset && op.metadata && op.metadata.dataset !== undefined) {
                op.entry.json.dataset = op.metadata.dataset;
            }
            if (op.entry && op.entry.json && !op.entry.json.info) {
                op.entry.json.info = {grid: op.metadata.grid, timestamp: this.parse_datetime(op.metadata.timestamp_epoch)};
                if(op.metadata.variables && op.metadata.variables[0]) {
                    op.entry.json.info.parm = [op.metadata.variables[0].parm];
                    op.entry.json.info.units = [op.metadata.variables[0].units];
                }
                if(op.metadata.url) {
                    op.entry.json.info.url = op.metadata.url;
                }
            }
        },
        get_dataset_obj: function () {
            if (!this.dataset_obj) {
                this.dataset_obj = OCS.Functions.get_dataset_from_node(this.get_dataset());
            }
            return this.dataset_obj;
        },
        destroy: function () {
            this.dataset_obj = null;
            this.setOptions(OCS.Interfaces.BaseData.options);
            this.id = null;
        }
    });
};
OCS.Classes.Data = OCS.Functions.define_Data_class();